import PropTypes from "prop-types";
import merge from "lodash/merge";
import ReactApexChart from "react-apexcharts";
// @mui
import { useTheme, styled } from "@mui/material/styles";
import { Card, CardHeader, Stack, Select, MenuItem } from "@mui/material";
// utils
import { fNumber } from "../../../utils/formatNumber";
// components
import { BaseOptionChart } from "../../../components/chart";
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../../core/redux/hooks";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 472;
const LEGEND_HEIGHT = 172;

export const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible",
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

// ----------------------------------------------------------------------

AppCurrentVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartColors: PropTypes.arrayOf(PropTypes.string),
  chartData: PropTypes.array,
};

export default function AppCurrentVisits({
  title,
  subheader,
  chartColors,
  chartData,
  ...other
}) {
  const theme = useTheme();

  const chartLabels = chartData.map((i) => i.label);

  const chartSeries = chartData.map((i) => i.value);

  const chartOptions = merge(BaseOptionChart(), {
    colors: chartColors,
    labels: chartLabels,
    stroke: { colors: [theme.palette.background.paper] },
    legend: { floating: true, horizontalAlign: "center" },
    dataLabels: { enabled: true, dropShadow: { enabled: false } },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `${seriesName}`,
        },
      },
    },
    plotOptions: {
      pie: { donut: { labels: { show: false } } },
    },
  });

  const dispatch = useAppDispatch();
  const [projection, setProjection] = useState("30-days");

  const handleProjection = (e) => {
    setProjection(e.target.value);
  };

  useEffect(() => {
    if (other.fetchFn) {
      dispatch(other.fetchFn(projection));
    }
  }, [projection]);

  return (
    <Card {...other}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        <CardHeader title={title} subheader={subheader} />

        <Select value={projection} onChange={handleProjection}>
          <MenuItem value={"all"}>In months</MenuItem>
          <MenuItem value={"90-days"}>last 90 days</MenuItem>
          <MenuItem value={"30-days"}>last 30 days</MenuItem>
          <MenuItem value={"14-days"}>last 14 days</MenuItem>
          <MenuItem value={"7-days"}>last 7 days</MenuItem>
        </Select>
      </Stack>

      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="pie"
          series={chartSeries}
          options={chartOptions}
          height={280}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
